import { QueryDocumentSnapshot, serverTimestamp, SnapshotOptions, Timestamp } from "firebase/firestore";

export default class Preacher {
    key: string;
    name: string;
    surname: string;
    churchFunction: string;
    email?: string;
    phoneNumber?: string;
    // Archived preachers keep their history but can no longer be chosen (GOD-33).
    archived?: boolean;
    // Consent to reminders per channel (GOD-35); written by the admin form or "Mein Plan".
    consents?: Partial<Record<"email" | "whatsapp", PreacherConsent>>;

    /**
     *
     */
    constructor(key: string, name: string, surname: string, churchFunction: string = "", email?: string, phoneNumber?: string) {
        this.key = key;
        this.name = name;
        this.surname = surname;
        this.churchFunction = churchFunction;
        this.email = email;
        this.phoneNumber = phoneNumber;
    }

    toString() {
        return this.key + ", " + this.name + ", " + this.surname + (this.churchFunction ? " (" + this.churchFunction + ")" : "");
    }
}

export interface PreacherConsent {
    given: boolean;
    at: Timestamp;
    source: "admin-oral" | "admin-written" | "self-service";
}

export const preacherConverter = {
    toFirestore: (preacher: Preacher) => {
        const data: any = {
            key: preacher.key,
            name: preacher.name,
            surname: preacher.surname,
            churchFunction: preacher.churchFunction,
            createdAt: serverTimestamp()
        };
        
        // Only include email if it's defined (Firestore rejects undefined values)
        if (preacher.email !== undefined) {
            data.email = preacher.email;
        }
        
        // Only include phoneNumber if it's defined (Firestore rejects undefined values)
        if (preacher.phoneNumber !== undefined) {
            data.phoneNumber = preacher.phoneNumber;
        }

        if (preacher.archived) {
            data.archived = true;
        }
        
        return data;
    },

    fromFirestore: (snapshot: QueryDocumentSnapshot, options: SnapshotOptions) => {
        const data = snapshot.data(options);
        const preacher = new Preacher(data!.key, data!.name, data!.surname, data!.churchFunction || "", data!.email, data!.phoneNumber);
        if (data!.archived === true) preacher.archived = true;
        if (data!.consents) preacher.consents = data!.consents;
        return preacher;
    }
}
